// import React, { useEffect, useState } from 'react'
// import { UserGet,UserPost,UserUpdate } from '../../Api/CoreApi'
// import { Form, Button, Input, message } from 'antd'
// import { Link, useNavigate } from 'react-router-dom'
// import "./User_Bank_Details.css";
// function User_Bank_Details() {
//     const Navigate = useNavigate();

//     const intid = localStorage.getItem('id')
//     const id = String(intid)
//     console.log(id, '********* id ********')

//     const [form] = Form.useForm();
//     const [isSidebarOpen, setIsSidebarOpen] = useState(false); // For mobile sidebar
//     const [data, setData] = useState([])


//     const user_role = localStorage.getItem('role')

//     const permission = () => {
//         if (user_role === null || user_role != 'user') {
//             Navigate('/')
//         }
//     }

//     const get = async () => {
//         try {
//             const response = await UserGet();
//             console.log(response)
//             const filter_user = response.filter(i => i.id === id);
//             console.log(filter_user, '********* V **********')
//             if (filter_user.length > 0) {
//                 form.setFieldsValue(filter_user[0]);
//                 setData(filter_user[0])
//             } else {
//                 message.warning("User not found.");
//             }
//         } catch (err) {
//             console.error("Failed to fetch user data", err);
//             message.error("Error fetching data.");
//         }
//     }

//     useEffect(() => {
//         permission()
//         get();
//     }, [])

//     const updatedata = async (value) => {
//         const intid = localStorage.getItem('id')
//         const id = String(intid)
//         // const data = {value}
//         const response = await UserUpdate(id , value)
//         console.log(response, '********* response *******')
//         const filter_user = response.filter(i => i.id === id);
//         form.setFieldsValue(filter_user[0]);
//         console.log(filter_user, '********* filter_user *******')
//         setData(filter_user)
//     }
//     const update = async (value) => {
//         console.log(value, '****** value ********')
//         // const intid = localStorage.getItem('id')
//         // const valueid = value[0].id
//         try {
//             const response = await UserUpdate(id, value);
//             const filter_user = response.filter(i => i.id === id);
//             form.setFieldsValue(filter_user[0]);
//             setData(filter_user)
//             console.log(response, '***** update response *****');
//             message.success("Bank details updated successfully!");
//         } catch (err) {
//             console.error("Update failed", err);
//             message.error("Failed to update bank details.");
//         }
//     }

//     const log_out = () => {
//         localStorage.clear()

//         // localStorage.removeItem('id')
//         Navigate('/User_Login')
//     }

//     const toggleSidebar = () => {
//         setIsSidebarOpen(!isSidebarOpen);
//     };

//     return (
//         <div>

//             <div className="app-header">
//                 <Link to='/' className="header-logo-link">
//                     <p className="header-logo-text">Ristey</p>
//                 </Link>
//                 <div className="header-right-content">
//                     <div className="header-nav-wrapper">
//                         {intid ? (
//                             <Link to='/User_Panel' className="header-nav-link profile-link">
//                                 <p>Profile</p>
//                             </Link>
//                         ) : (
//                             <div className="header-auth-links">
//                                 <Link to='/User_Reg/885695' className="header-nav-link">
//                                     <p>Sign Up</p>
//                                 </Link>
//                                 <Link to='/User_Login' className="header-nav-link">
//                                     <p>Login</p>
//                                 </Link>
//                             </div>
//                         )}
//                     </div>
//                     <Button className="sidebar-toggle-btn" onClick={toggleSidebar}>☰</Button>
//                 </div>
//             </div>

//             <div className={`app-sidebar ${isSidebarOpen ? 'open' : ''}`}>
//                 <Link to='/User_Panel'><Button className="sidebar-btn active">Dashboard</Button></Link>
//                 <Link to='/User_Recharge'><Button className="sidebar-btn">Recharge</Button></Link>
//                 <Link to='/User_Transaction_User'><Button className="sidebar-btn">Transaction</Button></Link>
//                 <Link to='/User_Added_User'><Button className="sidebar-btn">Share & Earn</Button></Link>
//                 {/* <Link to='/User_Bank_Details'><Button className="sidebar-btn">User Bank</Button></Link> */}
//                 {/* <Link to='/User_Withdrawal_User'><Button className="sidebar-btn">Withdrawal</Button></Link> */}
//                 {/* <Link to='/Post_Commission'><Button className="sidebar-btn">Commissions</Button></Link> */}
//                 <Button className="sidebar-btn" onClick={log_out}>Log Out</Button>
//             </div>
//             {data == '' && (
//                 <div className="form-wrapper">
//                     <div className="form-container">
//                         <div className="form-inner">
//                             <div style={{ textAlign: "center" }}>
//                                 <h1>  User Bank Details1 </h1>
//                             </div>
//                             <Form onFinish={updatedata} layout="vertical">
//                                 <Form.Item
//                                     label="Bank Account"
//                                     name="bank_account"
//                                     rules={[
//                                         { required: true, message: 'Bank account is required' },
//                                         { pattern: /^\d{9,18}$/, message: 'Enter a valid account number' },
//                                     ]}
//                                     className="form-item"
//                                 >
//                                     <Input placeholder="Enter your bank account number" className="form-input" />
//                                 </Form.Item>

//                                 <Form.Item
//                                     label="IFSC Code"
//                                     name="ifsc_code"
//                                     rules={[
//                                         { required: true, message: 'IFSC code is required' },
//                                         { pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/, message: 'Enter a valid IFSC code' },
//                                     ]}
//                                     className="form-item"
//                                 >
//                                     <Input placeholder="Enter IFSC code (e.g. SBIN0001234)" className="form-input" />
//                                 </Form.Item>

//                                 <Form.Item
//                                     label="UPI ID"
//                                     name="upi_id"
//                                     rules={[
//                                         { required: true, message: 'UPI ID is required' },
//                                         {
//                                             pattern: /^[\w.-]+@[\w.-]+$/,
//                                             message: 'Enter a valid UPI ID (e.g. name@bank)',
//                                         },
//                                     ]}
//                                     className="form-item"
//                                 >
//                                     <Input placeholder="Enter UPI ID" className="form-input" />
//                                 </Form.Item>

//                                 <Form.Item className="form-item-button">
//                                     <Button htmlType="submit" type="primary">Submit</Button>
//                                 </Form.Item>
//                             </Form>
//                         </div>
//                     </div>
//                 </div>
//             )}
//             {data != null && (
//                 <div className="form-wrapper">
//                     <div className="form-container">
//                         <div className="form-inner">
//                             <div style={{ textAlign: "center" }}>
//                                 <h1>  User Bank Details </h1>
//                             </div>
//                             <Form form={form} onFinish={update} layout="vertical">
//                                 <Form.Item
//                                     label="Bank Account"
//                                     name="bank_account"
//                                     rules={[
//                                         { required: true, message: 'Bank account is required' },
//                                         { pattern: /^\d{9,18}$/, message: 'Enter a valid account number' },
//                                     ]}
//                                     className="form-item"
//                                 >
//                                     <Input placeholder="Enter your bank account number" className="form-input" />
//                                 </Form.Item>

//                                 <Form.Item
//                                     label="IFSC Code"
//                                     name="ifsc_code"
//                                     rules={[
//                                         { required: true, message: 'IFSC code is required' },
//                                         { pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/, message: 'Enter a valid IFSC code' },
//                                     ]}
//                                     className="form-item"
//                                 >
//                                     <Input placeholder="Enter IFSC code (e.g. SBIN0001234)" className="form-input" />
//                                 </Form.Item>

//                                 <Form.Item
//                                     label="UPI ID"
//                                     name="upi_id"
//                                     rules={[
//                                         { required: true, message: 'UPI ID is required' },
//                                         {
//                                             pattern: /^[\w.-]+@[\w.-]+$/,
//                                             message: 'Enter a valid UPI ID (e.g. name@bank)',
//                                         },
//                                     ]}
//                                     className="form-item"
//                                 >
//                                     <Input placeholder="Enter UPI ID" className="form-input" />
//                                 </Form.Item>

//                                 <Form.Item className="form-item-button">
//                                     <Button htmlType="submit" type="primary">Update</Button>
//                                 </Form.Item>
//                             </Form>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     )
// }

// export default User_Bank_Details

import React from 'react'

function User_Bank_Details() {
  return (
    <div>User_Bank_Details</div>
  )
}

export default User_Bank_Details
